// DS: DS6.1
import React from 'react';
import c from 'classnames';
import RadioButton from '../../RadioButton';
import Flex from '../../Flex';
import { ThemeOverride } from '../../Context';
import { ThemeOptions } from '../../publicSession';
import Checkbox from '../../Checkbox';
import { IconSize } from '../../Icons/IconWrap';
import s from './SelectionListItem.scss';
var SelectionListItem = function (_a) {
    var label = _a.label, subLabel = _a.subLabel, prefix = _a.prefix, suffix = _a.suffix, SuffixIcon = _a.suffixIcon, isSelected = _a.isSelected, isDisabled = _a.isDisabled, control = _a.control, fillContainerWidth = _a.fillContainerWidth, showSuffixOnlyOnHover = _a.showSuffixOnlyOnHover, onClick = _a.onClick, onChange = _a.onChange;
    var onChangeHandler = function () {
        if (onChange) {
            onChange(!isSelected);
        }
        else if (onClick) {
            onClick();
        }
    };
    return (React.createElement(ThemeOverride, { theme: ThemeOptions.LIGHT, className: c(fillContainerWidth && s['fill-container-width']) },
        React.createElement("div", { className: c(s['root'], isSelected && s['selected'], isDisabled && s['disabled'], control === undefined && s['no-control'], fillContainerWidth && s['fill-container-width'], showSuffixOnlyOnHover && s['suffix-on-hover']), onClick: onChangeHandler },
            control && (React.createElement(Flex, { alignItems: "center", className: s['control'] },
                control === 'checkbox' && (React.createElement(Checkbox, { isChecked: isSelected, disabled: isDisabled, onChange: onChangeHandler })),
                control === 'radiobutton' && (React.createElement(RadioButton, { checked: isSelected, disabled: isDisabled, name: "name", value: "0", onChange: onChangeHandler })))),
            prefix && React.createElement("div", { className: s['prefix'] }, prefix),
            React.createElement(Flex, { direction: "column", justifyContent: "center", className: s['central-area'] },
                React.createElement("div", { className: s['label'] }, label),
                subLabel && React.createElement("div", { className: s['sub-label'] }, subLabel)),
            (suffix || SuffixIcon) && (React.createElement("div", { className: s['suffix'] },
                suffix,
                SuffixIcon && (React.createElement(SuffixIcon, { size: IconSize.MEDIUM, className: s['suffix-icon'], disableDefaultColors: true })))))));
};
SelectionListItem.displayName = 'SelectionListItem';
export default SelectionListItem;
//# sourceMappingURL=SelectionListItem.js.map